var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcArrow = function SvgIcArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M18 13.54a2.06 2.06 0 0 0-.46-1.3l-4.21-5.1a1.7 1.7 0 0 0-2.66 0l-4.21 5.1a2.1 2.1 0 0 0-.26 2.21 1.76 1.76 0 0 0 1.59 1.05h8.42a1.76 1.76 0 0 0 1.59-1.05c.13-.287.198-.597.2-.91"
  })));
};
export default SvgIcArrow;